import React from 'react';
import { Card, CardHeader, CardTitle, CardDescription } from './ui/card';
import { Code2, Globe, Rocket, Link, Headphones } from 'lucide-react';
import { services } from '../data/mock';

const iconMap = {
  Code2: Code2,
  Globe: Globe,
  Rocket: Rocket,
  Link: Link,
  Headphones: Headphones
};

const ServicesSection = () => {
  return (
    <section id="services" className="py-24 bg-white relative overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-slate-200 to-transparent" />
      
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-teal-600 font-semibold text-sm uppercase tracking-wider">What We Offer</span>
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mt-3 mb-6">
            Our Services
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            Comprehensive technology solutions designed to help your business thrive in the digital landscape.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, index) => {
            const IconComponent = iconMap[service.icon];
            return (
              <Card 
                key={service.id}
                className="group relative bg-white border border-slate-200 rounded-2xl p-8 transition-all duration-500 hover:shadow-xl hover:shadow-slate-200/50 hover:-translate-y-2 hover:border-slate-300 cursor-pointer overflow-hidden"
              >
                {/* Hover Gradient */}
                <div className="absolute inset-0 bg-gradient-to-br from-teal-50/0 to-slate-50/0 group-hover:from-teal-50/50 group-hover:to-slate-50/50 transition-all duration-500" />
                
                <CardHeader className="relative p-0">
                  {/* Icon */}
                  <div className="w-14 h-14 rounded-xl bg-slate-100 group-hover:bg-teal-100 flex items-center justify-center mb-6 transition-all duration-300 group-hover:scale-110">
                    <IconComponent className="w-7 h-7 text-slate-600 group-hover:text-teal-600 transition-colors duration-300" />
                  </div>
                  
                  <CardTitle className="text-xl font-semibold text-slate-900 mb-3 group-hover:text-slate-800">
                    {service.title}
                  </CardTitle>
                  
                  <CardDescription className="text-slate-600 leading-relaxed">
                    {service.description}
                  </CardDescription>
                </CardHeader>

                {/* Index Number */}
                <div className="absolute top-6 right-6 text-5xl font-bold text-slate-100 group-hover:text-teal-100 transition-colors duration-300">
                  0{index + 1}
                </div>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
